export default {
	setData(state, payload) {
		state.TransferInvList = payload.Data;
	},

	setTotalPage(state, payload) {
		state.Total = payload;
	},
	setTotalPageTransfer(state, payload) {
		state.Total = payload;
	},

	updateLoadingTotalRecords(state, res) {
		state.IsLoadingTotalRecords = res;
	},

	setDataDelete(state, item) {
		state.TransferInvList.remove(item);
		state.Total -= 1;
	}
};
